import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from 'primereact/checkbox';
import { UserConditionType, GenderType, ConditionUnitType } from '../../../common/enums'
import * as HelperFunctions from '../../../common/functions/helperFunctions';

const conditionUnitTypeList = (props) => {

    return (
        <DataTable
            value={props.unitRanges}
            paginator={true}
            lazy={true}
            rows={props.rows}
            totalRecords={props.totalRecords}
            onPage={(event) => props.onPageClick(event)}
            first={props.first}
            dataKey='conditionUnitRangeId'
        //loading={props.isLoading}	
        >
            <Column
                field="userConditionTypeId"
                header="User Condition"
                body={(rowData, column) =>
                    <div>
                        {rowData.userConditionTypeId ? HelperFunctions.getEnumLabel(rowData.userConditionTypeId, UserConditionType) : ""}
                    </div>
                }
            />
            <Column field="minValue" header="Min value" />
            <Column field="maxValue" header="Max value" />
            <Column
                field="genderTypeId"
                header="Gender"
                body={(rowData, column) =>
                    <div>
                        {rowData.genderTypeId ? HelperFunctions.getEnumLabel(rowData.genderTypeId, GenderType) : ""}
                    </div>
                }
            />
            <Column
                field="conditionUnitTypeconditionUnitType"
                header="Condition Unit Type"
                body={(rowData, column) =>
                    <div>
                        {rowData.conditionUnitType ? HelperFunctions.getEnumLabel(rowData.conditionUnitType, ConditionUnitType) : ""}
                    </div>
                }
            />
            <Column field="minAge" header="Min age" />
            <Column field="maxAge" header="Max age" />
            <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                    <div>
                        <Button
                            type="button"
                            icon="pi pi-pencil"
                            className="p-button-warning"
                            tooltip="Edit"
                            tooltipOptions={{ position: 'top' }}
                            style={{ marginRight: ".5em" }}
                            onClick={() => props.editClick(rowData.conditionUnitRangeId)}
                        />
                        <Button
                            type="button"
                            icon="pi pi-trash"
                            className="p-button-danger"
                            tooltip="Delete"
                            tooltipOptions={{ position: 'top' }}
                            onClick={() => props.deleteClick(rowData.conditionUnitRangeId)}
                        />
                    </div>
                }
            />
        </DataTable>
    )
}

export default conditionUnitTypeList;
